import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../home/ui/button';
import '../home/home.generated.css';

export default function Navbar(): JSX.Element {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleAnchorClick = (anchorId: string) => (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    setMobileOpen(false);
    if (location.pathname === '/') {
      const el = document.getElementById(anchorId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${anchorId}`);
    }
  };

  return (
    <div className='strada-public-home'>
      <header className='fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border'>
        <nav className='mx-auto flex max-w-6xl items-center justify-between md:grid md:grid-cols-[1fr_auto_1fr] px-6 py-4'>
          <Link to='/' className='flex items-center gap-2 no-underline justify-self-start' style={{ textDecoration: 'none' }} aria-label='Strada home'>
            <div className='flex h-8 w-8 items-center justify-center rounded-lg bg-teal'>
              <span className='text-sm font-bold text-navy'>S</span>
            </div>
            <span className='text-lg font-semibold tracking-tight text-foreground' style={{ fontFamily: 'var(--font-heading)' }}>
              Strada
            </span>
          </Link>

          <div className='hidden items-center gap-8 md:flex justify-self-center'>
            <a href='#risk' onClick={handleAnchorClick('risk')} className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
              The Risk
            </a>
            <a href='#platform' onClick={handleAnchorClick('platform')} className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
              Platform
            </a>
            <a href='#how-it-works' onClick={handleAnchorClick('how-it-works')} className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
              How It Works
            </a>
            <a href='#who' onClick={handleAnchorClick('who')} className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
              Who It&apos;s For
            </a>
          </div>

          <div className='hidden items-center gap-3 md:flex justify-self-end'>
            <Link
              to='/signin'
              className='text-sm font-medium text-muted-foreground transition-colors hover:text-foreground'
              style={{ textDecoration: 'none' }}
            >
              Log in
            </Link>
            <Button
              asChild
              size='lg'
              className='bg-foreground text-background hover:bg-foreground/90 rounded-full px-6 text-sm font-medium'
            >
              <Link to='/requestdemo'>Request a Demo</Link>
            </Button>
          </div>

          <button
            type='button'
            className='md:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-border bg-card text-foreground hover:bg-muted transition-colors'
            onClick={(): void => { setMobileOpen(!mobileOpen); }}
            aria-label='Toggle menu'
          >
            {mobileOpen ? <X className='h-5 w-5' /> : <Menu className='h-5 w-5' />}
          </button>
        </nav>

        {mobileOpen && (
          <div className='border-t border-border bg-background px-6 pb-6 pt-4 md:hidden'>
            <div className='flex flex-col gap-4'>
              <a href='#risk' className='text-sm text-muted-foreground' onClick={handleAnchorClick('risk')}>
                The Risk
              </a>
              <a href='#platform' className='text-sm text-muted-foreground' onClick={handleAnchorClick('platform')}>
                Platform
              </a>
              <a href='#how-it-works' className='text-sm text-muted-foreground' onClick={handleAnchorClick('how-it-works')}>
                How It Works
              </a>
              <a href='#who' className='text-sm text-muted-foreground' onClick={handleAnchorClick('who')}>
                Who It&apos;s For
              </a>
              <Link
                to='/signin'
                className='text-sm font-medium text-muted-foreground'
                style={{ textDecoration: 'none' }}
                onClick={(): void => { setMobileOpen(false); }}
              >
                Log in
              </Link>
              <Button
                asChild
                size='lg'
                className='bg-foreground text-background hover:bg-foreground/90 rounded-full mt-2 w-full text-sm font-medium'
              >
                <Link to='/requestdemo' onClick={(): void => { setMobileOpen(false); }}>
                  Request a Demo
                </Link>
              </Button>
            </div>
          </div>
        )}
      </header>
    </div>
  );
}
